
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[smartBanner]",
      function () {
        return require("private-next-pages/[smartBanner]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[smartBanner]"])
      });
    }
  